export enum METRIC {
  Error = 'Error',
  Fatal = 'Fatal',
  MidwayTokenFetchFailure = 'MidwayTokenFetchFailure',
  NotFound = 'NotFound',
}
